import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Nav, Tab, OverlayTrigger, Tooltip, Button, Modal, ModalFooter, Carousel } from 'react-bootstrap'
import { Link, useNavigate, Route } from 'react-router-dom'
// images
import sideImage from '../assets/images/getappimg/img.webp'
import apple from '../assets/images/getappimg/1.svg'
import android from '../assets/images/getappimg/2.svg'

import { apiHandler } from '../api/apihandler';
import { ANNOUNCEMENT_API } from "../api/constants";


const Announcement = ({ }) => {
    const [announcementsList, setAnnouncementsList] = useState([]);
    useEffect(() => {
        getAnnoucementApi()
    }, [])

    async function getAnnoucementApi() {
        try {
            const res = await apiHandler(ANNOUNCEMENT_API, "POST")
            if (res.data?.response?.status === 200) {
                setAnnouncementsList(res?.data?.data?.publicAnnouncements || [])
            }
        } catch (error) {
            console.error(error);
        }
        finally {
        }
    }

    // Don't render if no announcements
    if (!announcementsList || announcementsList.length === 0) {
        return null;
    }

    return (
        <div className="d-flex flex-wrap" 
        style={{ justifyContent: "", background: "#5c2a83", paddingTop: "15px", paddingBottom: "15px", paddingLeft: "15px" }}>
            <div style={{ width: "211px", justifyContent: "center" }}>
                <h3 style={{ color: "#FFF" }}>Announcement :</h3>
            </div>
            <div className="d-flex align-items-center" style={{ width: "85%", justifyContent: "left" }}>
                <div style={{ width: "100%" }}>
                    {announcementsList.length === 1 ? (
                        // Single announcement - display without carousel
                        <h4 style={{ color: "#FFF" }}>
                            {announcementsList[0]?.announcement_details}
                            {announcementsList[0]?.link_text && (
                                <>
                                    {" - "}
                                    <b>
                                        <Link to={announcementsList[0]?.link} style={{color: "#FFF"}}>
                                            {announcementsList[0]?.link_text}
                                        </Link>
                                    </b>
                                </>
                            )}
                        </h4>
                    ) : (
                        // Multiple announcements - use carousel
                        <Carousel 
                            indicators={false} 
                            controls={announcementsList.length > 1}
                            interval={5000}
                            pause="hover"
                            nextIcon={<span className="carousel-control-next-icon" style={{ filter: "invert(1)" }} />}
                            prevIcon={<span className="carousel-control-prev-icon" style={{ filter: "invert(1)" }} />}
                        >
                            {announcementsList.map((announcement, index) => (
                                <Carousel.Item key={announcement.id || index}>
                                    <div style={{ minHeight: "50px", display: "flex", alignItems: "center" }}>
                                        <h4 style={{ color: "#FFF", margin: 0 }}>
                                            {announcement?.announcement_details}
                                            {announcement?.link_text && (
                                                <>
                                                    {" - "}
                                                    <b>
                                                        <Link to={announcement?.link} style={{color: "#FFF"}}>
                                                            {announcement?.link_text}
                                                        </Link>
                                                    </b>
                                                </>
                                            )}
                                        </h4>
                                    </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Announcement
